module.exports = __webpack_public_path__ + "img/sec2.2.143844e5.png";